// @flow

import type { ICellRendererParams } from "ag-grid-react";

/**
 * loupeIcon
 *
 * A function cell renderer for displaying a magnifying glass (loupe) svg icon
 *
 * @param {*} params
 */
export default function loupeIcon(params: ICellRendererParams) {
  return `
    <div class="pointer">
      <svg
        class="icons coffee-d3 no-pointer-events"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
      >
        <g>
          <circle cx="8.79166667" cy="8.79166667" r="7.33333333" />
          <path d="M13.9763333,13.9763333 L22.5416667,22.5416667" />
        </g>
      </svg>
    </div>
  `;
}
